import React from "react";
import PostalCodeInput from "../PostalCodeInput";
import { getMask, insertSpace, shouldInsertSpace } from "./utils";

function handleOnBlur(onBlur: ((e: { target: { value: string } }) => void) | undefined) {
    return (e: { target: { value: string } }) => {
        const newValue = shouldInsertSpace(e.target.value) ? insertSpace(e.target.value) : e.target.value;

        const newEvent = { ...e, target: Object.assign(e.target, { value: newValue.toUpperCase() }) };

        onBlur && onBlur(newEvent);
    };
}

interface CAPostalCodeProps {
    locationType?: string;
    placeholder?: string;
    value?: string | null;
    onBlur?: (e: any) => void;
    onChange?: (e: { target: { value: string } }) => void;
    className?: string;
}

const CAPostalCode: React.FunctionComponent<CAPostalCodeProps> = ({ onBlur, ...rest }) => (
    <PostalCodeInput mask={getMask} maskChar="_" onBlur={handleOnBlur(onBlur)} {...rest} />
);

CAPostalCode.defaultProps = {
    placeholder: "Postal code",
};

export default CAPostalCode;
